<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	import { valueOutOfRange } from '../../../../helpers/utilities';
	//Services
	import { postReq } from '../../../../services/http';
	//Stores
	//Design system components
	import { Text, Input, Button } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	import type { Device } from '../../../../types/Device';
	export let device: Device;

	const id = real_id(device.id),
		settings = readDeviceSettings(id)?.sensors,
		min = 1,
		max = 60,
		save = async () => {
			waitForResponse = true;
			const res: SettingRequest = await postReq(`/device/${device.category}/settings/motion`, {
				id,
				duration: value,
			});
			onSettingsResponse(res, device);
			waitForResponse = false;
		};

	let value = settings.motion_duration,
		waitForResponse = false;
</script>

<Text styleType="body-small" class="mb-s"
	>{$format('moiton_duration_set_up_description', {
		values: { min, max },
		default: `Specify duration in seconds (from ${min} to ${max}) to hold motion detected state in order to avoid frequent detections.`,
	})}</Text
>

<Input
	size="m"
	icon="fas fa-person-walking"
	class="mb-s"
	bind:value
	error={valueOutOfRange(value, min, max)
		? $format('min_max_error_description', {
				values: { min, max },
				default: 'Value must be between {min} and {max}.',
			})
		: ''}
	id="input-oiea8du"
	aria-label={$format('moiton_duration_set_up_description', {
		default: `Specify duration in seconds to hold motion detected state.`,
	})}
/>

<Button
	size="m"
	width="full"
	loading={waitForResponse}
	disabled={valueOutOfRange(value, min, max)}
	on:click={save}>{$format('button_save', { default: 'Save' })}</Button
>
